// UploadedDocs.jsx

import React from "react";
import TableDigiUpload from "./TableDigiUpload";
import ViewDoc from "../../assets/img/eye-icon-black.svg";
import DownloadDoc from "../../assets/img/download-icon-black.svg";
import EditDoc from "../../assets/img/penEditDarkGrey.png";
import UploadBox from "../../assets/img/File-upload-box-blue.svg";
import DocumentIcon from "../../assets/img/DocumentTypeIcon.svg";
import closeIcon from "../../assets/img/close-Dark-Icon.svg";

function UploadedDocs() {
  return (
    <>
      <div
        className="container-fluid row m-0 p-3"
        style={{ background: "#F9FAFB" }}
      >
        <h2 className="eduHeading col-12 pb-4">
          Uploaded documents via Digil locker
        </h2>

        <TableDigiUpload
          headers={[
            "Qualification",
            "University/Board",
            "Roll Number",
            "Year of Passing",
            "Document Type",
            "Action",
          ]}
          data={[
            [
              "1Senior Sec (12th)",
              "CBSE",
              "9876543210",
              "2010",
              "Marksheet",
              <div className="d-flex justify-content-start align-content-center">
                <span>
                  <img
                    style={{ cursor: "pointer" }}
                    src={ViewDoc}
                    alt="ViewDoc"
                  />
                </span>{" "}
                &nbsp; &nbsp;
                <span>
                  <img
                    style={{ cursor: "pointer" }}
                    src={DownloadDoc}
                    alt="DownloadDoc"
                  />
                </span>
              </div>,
            ],
            [
              "1Senior Sec (12th)",
              "CBSE",
              "9876543210",
              "2010",
              "Marksheet",
              <div className="d-flex justify-content-start align-content-center">
                <span>
                  <img
                    style={{ cursor: "pointer" }}
                    src={ViewDoc}
                    alt="ViewDoc"
                  />
                </span>{" "}
                &nbsp; &nbsp;
                <span>
                  <img
                    style={{ cursor: "pointer" }}
                    src={DownloadDoc}
                    alt="DownloadDoc"
                  />
                </span>
              </div>,
            ],
          ]}
        />

        <div className="headings col-12 pb-4">
          <h2 className="eduHeading">Not Available on Digilocker</h2>
          <div className="subHead">
            Review your information and retry with correct information if
            requires
          </div>
        </div>

        <TableDigiUpload
          headers={[
            "Qualification",
            "University/Board",
            "Roll Number",
            "Year of Passing",
            "Document Type",
            "Action",
          ]}
          data={[
            [
              "1Senior Sec (12th)",
              "CBSE",
              "9876543210",
              "2010",
              <div className="text-danger">
                Not Available<sup>*</sup>
              </div>,
              " ",
            ],
            [
              "1Senior Sec (12th)",
              "CBSE",
              "9876543210",
              "2010",
              <div className="text-danger">
                Not Available<sup>*</sup>
              </div>,
              " ",
            ],
          ]}
        />

        <div className="headings col-12 pb-4 pt-0">
          <div className="subHead">
            <sup>*</sup> This will not affect your verification journey
          </div>
        </div>

        <div className="headings col-12 pb-4">
          <h2 className="eduHeading">Uploaded documents via Digil locker</h2>
          <div className="subHead">
            Not available on digilocker please upload manually
          </div>
        </div>

        {/* card */}
        <div className="card-box p-2 py-3 mb-4 w-100">
          <div className="row head-row d-flex justify-content-between">
            <div className="">
              <h2 className="eduHeading col-12 pb-4">Education 3:</h2>
            </div>
            <div className="custom-checkbox d-flex align-content-center pr-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
              />
              <label className="form-check-label pt-1 pl-2" for="exampleCheck1">
                I will submit documents later
              </label>
            </div>

            <TableDigiUpload
              className="p-"
              headers={[
                "Qualification",
                "University/Board",
                "Roll Number",
                "Year of Passing",
                "Location",
                "Action",
              ]}
              data={[
                [
                  "1Senior Sec (12th)",
                  "CBSE",
                  "9876543210",
                  "2010",
                  "New Delhi",
                  <div
                    className="d-flex justify-content-start align-content-center"
                    style={{ cursor: "pointer" }}
                  >
                    <span>
                      <img
                        style={{ cursor: "pointer" }}
                        src={EditDoc}
                        alt="ViewDoc"
                      />
                    </span>
                    <span>&nbsp; Edit</span>
                  </div>,
                ],
                [
                  "1Senior Sec (12th)",
                  "CBSE",
                  "9876543210",
                  "2010",
                  "New Delhi",
                  <div
                    className="d-flex justify-content-start align-content-center"
                    style={{ cursor: "pointer" }}
                  >
                    <span>
                      <img
                        style={{ cursor: "pointer" }}
                        src={EditDoc}
                        alt="ViewDoc"
                      />
                    </span>
                    <span>&nbsp; Edit</span>
                  </div>,
                ],
              ]}
            />

            <div className="error-text col-12 py-2">
              Note: Kindly be aware that you will be requested to resubmit the
              required documents.
            </div>
          </div>
        </div>

        {/* card */}
        <div className="card-box p-2 py-3 mb-4 w-100">
          <div className="row head-row d-flex justify-content-between">
            <div className="">
              <h2 className="eduHeading col-12 pb-4">Education 4:</h2>
            </div>
            <div className="custom-checkbox d-flex align-content-center pr-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
              />
              <label className="form-check-label pt-1 pl-2" for="exampleCheck1">
                I will submit documents later
              </label>
            </div>

            <TableDigiUpload
              className="p-"
              headers={[
                "Qualification",
                "University/Board",
                "Roll Number",
                "Year of Passing",
                "Location",
                "Action",
              ]}
              data={[
                [
                  "1Senior Sec (12th)",
                  "CBSE",
                  "9876543210",
                  "2010",
                  "New Delhi",
                  <div
                    className="d-flex justify-content-start align-content-center"
                    style={{ cursor: "pointer" }}
                  >
                    <span>
                      <img
                        style={{ cursor: "pointer" }}
                        src={EditDoc}
                        alt="ViewDoc"
                      />
                    </span>
                    <span>&nbsp; Edit</span>
                  </div>,
                ],
                [
                  "1Senior Sec (12th)",
                  "CBSE",
                  "9876543210",
                  "2010",
                  "New Delhi",
                  <div
                    className="d-flex justify-content-start align-content-center"
                    style={{ cursor: "pointer" }}
                  >
                    <span>
                      <img
                        style={{ cursor: "pointer" }}
                        src={EditDoc}
                        alt="ViewDoc"
                      />
                    </span>
                    <span>&nbsp; Edit</span>
                  </div>,
                ],
              ]}
            />

            <div className="card-upload-box col-12 row p-0 m-0">
              <div className="col-lg-6 col-md-6 col-sm-12 py-2">
                <div className="upload-heading pb-2">
                  Upload Marksheets (All semester)
                </div>
                <div className="upload-box-img">
                  <img className="w-100" src={UploadBox} alt="UploadBox" />
                </div>
                <div className="upload-box-docs d-flex justify-content-between align-content-center my-3">
                  <div className="upload-box-docs-sec-1 d-flex justify-content-start align-content-center">
                    <img
                      src={DocumentIcon}
                      alt="DocumentIcon"
                      style={{
                        cursor: "pointer",
                        width: "16px",
                        height: "16px",
                      }}
                    />
                    <div className="docName pl-3">Name</div>
                  </div>
                  <div className="upload-box-docs-sec-2 d-flex justify-content-end align-content-center">
                    <span>
                      <img
                        style={{ cursor: "pointer", marginLeft: "9px" }}
                        src={ViewDoc}
                        alt="ViewDoc"
                      />
                    </span>
                    <span>
                      <img
                        style={{ cursor: "pointer", marginLeft: "9px" }}
                        src={DownloadDoc}
                        alt="DownloadDoc"
                      />
                    </span>
                    <span>
                      <img
                        style={{
                          cursor: "pointer",
                          marginLeft: "9px",
                          height: "16px",
                          width: "16px",
                        }}
                        src={closeIcon}
                        alt="CloseIcon"
                      />
                    </span>
                  </div>
                </div>
                <div className="upload-box-docs d-flex justify-content-between align-content-center my-3">
                  <div className="upload-box-docs-sec-1 d-flex justify-content-start align-content-center">
                    <img
                      src={DocumentIcon}
                      alt="DocumentIcon"
                      style={{
                        cursor: "pointer",
                        width: "16px",
                        height: "16px",
                        marginTop: "3px",
                      }}
                    />
                    <div className="docName pl-3">Name</div>
                  </div>
                  <div className="upload-box-docs-sec-2 d-flex justify-content-end align-content-center">
                    <span>
                      <img
                        style={{ cursor: "pointer", marginLeft: "9px" }}
                        src={ViewDoc}
                        alt="ViewDoc"
                      />
                    </span>
                    <span>
                      <img
                        style={{ cursor: "pointer", marginLeft: "9px" }}
                        src={DownloadDoc}
                        alt="DownloadDoc"
                      />
                    </span>
                    <span>
                      <img
                        style={{
                          cursor: "pointer",
                          marginLeft: "9px",
                          height: "16px",
                          width: "16px",
                        }}
                        src={closeIcon}
                        alt="CloseIcon"
                      />
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 py-2">
                <div className="upload-heading pb-2">
                  Upload Degree/certificate
                </div>
                <div className="upload-box-img">
                  <img className="w-100" src={UploadBox} alt="UploadBox" />
                </div>
                <div className="upload-box-docs d-flex justify-content-between align-content-center my-3">
                  <div className="upload-box-docs-sec-1 d-flex justify-content-start align-content-center">
                    <img
                      src={DocumentIcon}
                      alt="DocumentIcon"
                      style={{
                        cursor: "pointer",
                        width: "16px",
                        height: "16px",
                        marginTop: "3px",
                      }}
                    />
                    <div className="docName pl-3">Name</div>
                  </div>
                  <div className="upload-box-docs-sec-2 d-flex justify-content-end align-content-center">
                    <span>
                      <img
                        style={{ cursor: "pointer", marginLeft: "9px" }}
                        src={ViewDoc}
                        alt="ViewDoc"
                      />
                    </span>
                    <span>
                      <img
                        style={{ cursor: "pointer", marginLeft: "9px" }}
                        src={DownloadDoc}
                        alt="DownloadDoc"
                      />
                    </span>
                    <span>
                      <img
                        style={{
                          cursor: "pointer",
                          marginLeft: "9px",
                          height: "16px",
                          width: "16px",
                        }}
                        src={closeIcon}
                        alt="CloseIcon"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 buttons d-flex justify-content-start align-items-center">
          <div className="btn btn-white text-dark">Back</div>
          <div
            className="btn btn-primary ml-2"
            // onClick={SubmitPopUp}
            type="button"
            data-toggle="modal"
            data-target="#SubmitPopUp"
          >
            Continue
          </div>

          {/* Modal */}
          <div
            className="modal fade"
            id="SubmitPopUp"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-bottom-0">
                  <h4 className="modal-title" id="staticBackdropLabel">
                    Submit without documents
                  </h4>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p className="subHead">
                    Documents are not fetched for ‘count’ education(s). If you
                    wish to submit anyway, please select the reason.
                  </p>
                  <h5>Select Reason</h5>

                  <div className="btn-group pb-3">
                    <button
                      type="button"
                      className="btn btn-white dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Select Reason
                    </button>
                    <div className="dropdown-menu">
                      <div className="dropdown-item">
                        My mobile no. is not linked with my Aadhaar
                      </div>
                      <div className="dropdown-item">
                        Unable to fetch my documents after retry
                      </div>
                      <div className="dropdown-item">
                        I do not wish to fetch documents from DigiLocker
                      </div>
                      <div className="dropdown-item">Other</div>
                    </div>
                  </div>
                  <form>
                    <div className="form-group">
                      <textarea
                        className="form-control"
                        placeholder="Add Reasone"
                        id="exampleFormControlTextarea1"
                        rows="3"
                      ></textarea>
                    </div>
                  </form>
                </div>
                <div className="modal-footer justify-content-start border-top-0">
                  <button
                    type="button"
                    className="btn btn-white text-dark"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UploadedDocs;
